//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: Object,
      default() {},
    },
    alternativeIcon: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'accordion',
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isExpanded: false,
    }
  },
  computed: {
    conrolId() {
      return this.id + '-panel-' + this.index
    },
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded
    },
  },
}
